exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cw__hero-banner[data-v-5b317b2e]::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background: rgb(0, 0, 0);\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0.1) 40%,\n    rgba(0, 0, 0, 0.5) 75%,\n    rgba(0, 0, 0, 0.8) 100%\n  );\n}\n\n/* md and up */\n@media (min-width: 768px) {\n.md\\:cw__aspect-ratio--1[data-v-5b317b2e] {\n    aspect-ratio: 1;\n}\n.md\\:cw__flex-basis-0[data-v-5b317b2e] {\n    flex-basis: 0px;\n}\n}\n", ""]);

// exports
